import routes from "web/routes/constants"
import { Badge } from "web/components"

export default function AssetsMissingMandatoryFields({ deal, dealAssets }) {
  return (
    <section className="mt-5">
      <header className="my-3 border-0 border-b border-neutral-9 py-1 text-sm uppercase text-neutral-3">
        Assets
      </header>
      <div className="mt-2 flex flex-col">
        {dealAssets.map((dealAsset, i) => {
          const missingMandatoryFields = dealAsset.fields.filter(
            (stage_field) => stage_field.mandatory
          )
          return (
            <div
              key={i}
              className="mx-2 mt-2 flex items-center rounded-md border bg-white p-2.5 text-sm shadow-sm"
            >
              <div className="flex-auto">
                <a
                  className="my-0.5 text-sm font-medium text-primary-4 hover:text-feature-6"
                  href={`${routes.deal_asset(
                    "all",
                    null,
                    deal.id,
                    dealAsset.id
                  )}/details`}
                  data-turbo-frame="_top"
                >
                  {dealAsset.name}
                </a>
              </div>
              <div>
                <div className="ml-2 mt-0.5">
                  <Badge badgeColour="bg-red-600">
                    {missingMandatoryFields.length}
                  </Badge>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
